import { NavLink } from "react-router-dom";
import { useSiteData } from "../../app/SiteDataContext";

function Header() {
  const { navigation, settings } = useSiteData();
  const siteProfile = settings.siteProfile;
  const headerCta = settings.header || {
    ctaLabel: "Proje Baslat",
    ctaPath: "/iletisim",
  };

  return (
    <header className="site-header">
      <div className="glass-panel navbar">
        <NavLink className="brand-mark" to="/">
          <span className="brand-dot" />
          <div>
            <strong>{siteProfile.name}</strong>
            <span>{siteProfile.role}</span>
          </div>
        </NavLink>

        <nav className="nav-links" aria-label="Primary">
          {navigation.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `nav-link${isActive ? " nav-link-active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <NavLink
          className="button button-primary button-compact"
          to={headerCta.ctaPath}
        >
          {headerCta.ctaLabel}
        </NavLink>
      </div>
    </header>
  );
}

export default Header;
